(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('react')) :
	typeof define === 'function' && define.amd ? define(['react'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, (global["dist/index"] = global["dist/index"] || {}, global["dist/index"].js = factory(global.React)));
})(this, (function (React) { 'use strict';

	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

	var classnames = {exports: {}};

	/*!
		Copyright (c) 2018 Jed Watson.
		Licensed under the MIT License (MIT), see
		http://jedwatson.github.io/classnames
	*/

	(function (module) {
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames() {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
						classes.push(arg.toString());
						continue;
					}

					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if (module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else {
			window.classNames = classNames;
		}
	}());
	}(classnames));

	var classNames = classnames.exports;

	function styleInject(css, ref) {
	  if (ref === void 0) ref = {};
	  var insertAt = ref.insertAt;
	  if (!css || typeof document === 'undefined') {
	    return;
	  }
	  var head = document.head || document.getElementsByTagName('head')[0];
	  var style = document.createElement('style');
	  style.type = 'text/css';
	  if (insertAt === 'top') {
	    if (head.firstChild) {
	      head.insertBefore(style, head.firstChild);
	    } else {
	      head.appendChild(style);
	    }
	  } else {
	    head.appendChild(style);
	  }
	  if (style.styleSheet) {
	    style.styleSheet.cssText = css;
	  } else {
	    style.appendChild(document.createTextNode(css));
	  }
	}

	var css_248z = "/* Consolidation of frequently used colours throughout the repo */\n.tooltipContainer {\n  display: inline-block;\n  position: relative;\n}\n.tooltipContainer:focus .tooltiptext, .tooltipContainer:hover .tooltiptext {\n  visibility: visible;\n}\n.tooltipContainer > div {\n  color: #051d33;\n  font-size: 1rem;\n}\n.tooltipContainer .tooltiptext {\n  top: 0;\n  left: 0;\n  position: absolute;\n  visibility: hidden;\n  min-width: 4rem;\n  text-align: center;\n  border-radius: 4px;\n  padding: 0.5rem;\n  transition: opacity 0.6s;\n  font-size: 1rem;\n  font-family: avenir_lt_medium;\n  background-color: #024055;\n  color: #ffffff;\n  text-shadow: none;\n  z-index: 1050;\n  text-transform: none;\n  text-wrap: wrap;\n}\n.tooltipContainer .tooltiptext.bottom {\n  transform: translate(-50%, 30%);\n}\n.tooltipContainer .tooltiptext.top {\n  transform: translate(-50%, -100%);\n}\n.tooltipContainer .tooltiptext.left {\n  transform: translate(-100%, -40%);\n}\n.tooltipContainer .tooltiptext.right {\n  transform: translate(10%, -40%);\n}";
	styleInject(css_248z);

	var ToolTip = function (_a) {
	    var children = _a.children, message = _a.message, _b = _a.onClick, onClick = _b === void 0 ? function (event) {
	        event.stopPropagation();
	    } : _b, _c = _a.onKeyDown, onKeyDown = _c === void 0 ? function (event) {
	        event.stopPropagation();
	    } : _c, toolTipId = _a.toolTipId, _d = _a.toolTipStyle, toolTipStyle = _d === void 0 ? {} : _d, _e = _a.position, position = _e === void 0 ? 'top' : _e;
	    return (React__default["default"].createElement("div", { className: 'tooltipContainer', "data-testid": 'tooltip-container', tabIndex: 0, role: 'button', onClick: onClick, onKeyDown: onKeyDown },
	        React__default["default"].createElement("span", { "data-testid": 'tooltiptext', className: classNames('tooltiptext', position), style: toolTipStyle, id: toolTipId }, message),
	        React__default["default"].createElement("div", null, children)));
	};

	return ToolTip;

}));
